// verify.sign.yt serves only the public verify page (/ and /<code>).
export const VERIFY_HOST = import.meta.env.VITE_VERIFY_HOST || 'verify.sign.yt'
export const isVerifyHost = typeof window !== 'undefined' && window.location.hostname === VERIFY_HOST
export const VERIFY_CODE_RE = /^[A-Za-z0-9]{16}$/
